import { useState } from 'react';
import Link from 'next/link';
import classnames from 'classnames';

import MarkdownRenderer from '@/components/MarkdownRenderer';
import Testimonial from '@/components/Testimonial';

export default function CaseStudyTabs({ items = [] }) {
  const hasItems = items || items.length > 0;
  const [activeItem, setActiveItem] = useState(hasItems && items[0]);

  if (!hasItems) return null;

  return (
    <div className="py-12 md:pt-24">
      <div className="flex overflow-hidden pb-6 md:-mb-6 md:justify-end md:pb-0">
        <div className="w-full overflow-x-auto md:w-1/2 md:pl-6 lg:pl-10">
          <div className="inline-flex space-x-6 border-b border-rock-blue">
            {items.map((item) => {
              const isActive = item === activeItem;

              return (
                <button
                  key={item.id}
                  type="button"
                  onClick={() => setActiveItem(item)}
                  className={classnames(
                    'focus:outline-none -mb-px flex-shrink-0 appearance-none border-b py-2 text-sm font-medium uppercase tracking-wider',
                    {
                      'border-royal-blue text-royal-blue': isActive,
                      'border-rock-blue text-rock-blue': !isActive,
                    },
                  )}
                >
                  {item.company.name}
                </button>
              );
            })}
          </div>
        </div>
      </div>

      <div className="md:flex md:items-center md:space-x-12 lg:space-x-20">
        <div className="md:w-1/2">
          <Testimonial
            {...activeItem}
            linkPath={`/case-studies/${activeItem.slug}`}
          />
        </div>

        <div className="relative md:w-1/2">
          <div>
            <MarkdownRenderer content={activeItem?.excerpt} />

            {activeItem?.hasContent && (
              <Link href={activeItem?.linkPath} prefetch={false}>
                <a className="group font-medium text-royal-blue">
                  Read case study
                  <span className="ml-1 inline-block transform transition-transform duration-100 group-hover:translate-x-1">
                    &#8594;
                  </span>
                </a>
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
